import { Box, FormLabel, TextField } from "@mui/material";
import ErrorBox from "../../../components/shared/boxes/ErrorBox";
import { useEffect, useState } from "react";

const InvoiceCheckout = ({ data, setData, apiError }) => {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        if (apiError) {
            setOpen(true);
        }
    }, [apiError]);

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {apiError && open && (
                <Box sx={{ mb: '1rem' }}>
                    <ErrorBox
                        errorMessage={apiError.errorMessage}
                        onClose={() => setOpen(false)}
                    />
                </Box>
            )}

            <FormLabel sx={{ color: 'text.primary' }}><b>Informações adicionais</b></FormLabel>
            <TextField
                multiline
                minRows={1}
                maxRows={8}
                sx={{
                    minWidth: '30rem',
                    maxWidth: '60%'
                }}
                variant="outlined"
                placeholder='Digitar texto'
                value={data.addInformation || ''}
                onChange={(e) =>
                    setData((prev) => ({ ...prev, addInformation: e.target.value }))
                }
            />
        </Box>
    )
}

export default InvoiceCheckout; 